import { useEffect, useRef, useCallback, useState } from "react"

const COPY_FEEDBACK_DURATION_MS = 1500

export const useEscapeKey = (handler) => {
  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && handler()
    document.addEventListener("keydown", onKeyDown)
    return () => document.removeEventListener("keydown", onKeyDown)
  }, [handler])
}

export const useOverlayClick = (onClose) =>
  useCallback(
    (e) => {
      if (e.target === e.currentTarget) onClose()
    },
    [onClose]
  )

export const useClickOutside = (handler) => {
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        handler()
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [handler])

  return ref
}

export const useCopyFeedback = (copyFn) => {
  const [showingFeedback, setShowingFeedback] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const triggerCopy = useCallback(async () => {
    await copyFn()
    setShowingFeedback(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => setShowingFeedback(false), COPY_FEEDBACK_DURATION_MS)
  }, [copyFn])

  return [showingFeedback, triggerCopy]
}
